import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import type { CurrentCash, ClosingResult, CashOpening } from "../models";

@Injectable({ providedIn: "root" })
export class CashService {
  private readonly base = `${environment.apiUrl}/cash`;

  constructor(private readonly http: HttpClient) {}

  getCurrent(currency: string = "PEN", userId?: string) {
    let params = new HttpParams().set("currency", currency);
    if (userId) params = params.set("userId", userId);
    return this.http.get<CurrentCash>(`${this.base}/current`, { params });
  }

  getAll(userId?: string) {
    let params = new HttpParams().set("all", "true");
    if (userId) params = params.set("userId", userId);
    return this.http.get<Record<string, CurrentCash>>(`${this.base}/current`, { params });
  }

  open(data: { openingAmount: number; currency?: string; notes?: string }) {
    return this.http.post<CashOpening>(`${this.base}/open`, data);
  }

  close(data: { countedBalance: number; currency?: string; notes?: string }) {
    return this.http.post<ClosingResult>(`${this.base}/close`, data);
  }
}
